<template>
  <MoleculeEditionProductSatellitesIncludedList
    v-if="habilitada"
    :element="element"
    tipo="ia_mensual"
  />
</template>

<script>
/*
 | Los planes mensuales de IA se incluyen con la misma lista que los Droops: tipo es la clave literal
 | del API, con la que la lista lee el GET, arma el PUT y busca sus textos.
 |
 | Hasta que la venta de IA salga (el interruptor de los Ajustes de IA), ademas de ocultar el item,
 | la URL directa vuelve a Satelites Incluidos, para que no se pueda armar un producto con IA por la
 | puerta de atras.
 */
export default {
  name: 'MoleculeEditionProductArtificialIntelligenceMensual',

  components: {
    MoleculeEditionProductSatellitesIncludedList: () =>
      import('@/components/molecules/MoleculeEditionProductSatellitesIncludedList')
  },

  props: {
    element: Object
  },

  computed: {
    habilitada () {
      return this.$iaVisible.visible
    }
  },

  created () {
    if (!this.habilitada) {
      this.$router.replace(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.satellitesIncluded.subject')}/${this.$t('mEditionMenu.product.satellitesIncluded.children.juedroop.subedition')}`)
    }
  }
}
</script>
